import { useState } from "react";
import { Search, Plus, Check } from "lucide-react";
import { initials, fmtListTime } from "./util";

const FILTERS = [["all", "All"], ["unread", "Unread"], ["needs_reply", "Needs reply"], ["mine", "Mine"], ["closed", "Closed"]];

function ChatRow({ c, active, onOpen }) {
  return (
    <button onClick={() => onOpen(c.phone)} data-testid={`inbox-chat-${c.phone}`}
      className={`w-full flex items-center gap-3 px-3 py-3 text-left border-b border-slate-100 transition-colors ${active ? "bg-[#f0f2f5]" : "hover:bg-[#f5f6f6]"}`}>
      <div className="w-12 h-12 rounded-full bg-[#dfe5e7] text-[#54656f] flex items-center justify-center font-semibold flex-shrink-0">{initials(c.display_name)}</div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="font-medium text-[#111b21] truncate">{c.display_name}</span>
          <span className={`text-[11px] flex-shrink-0 ${c.unread ? "text-[#1fa855] font-semibold" : "text-[#667781]"}`}>{fmtListTime(c.last_message_at)}</span>
        </div>
        <div className="flex items-center justify-between gap-2 mt-0.5">
          <span className="text-[13px] text-[#667781] truncate flex items-center gap-1">
            {c.last_direction === "out" && c.last_preview && <span className="flex-shrink-0">You:</span>}
            {c.last_preview || <i>No messages yet</i>}
          </span>
          {c.unread > 0 && <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-[#25d366] text-white text-[11px] font-bold flex items-center justify-center" data-testid="inbox-chat-unread">{c.unread}</span>}
        </div>
        {(c.labels?.length > 0 || c.status === "closed") && (
          <div className="flex gap-1 mt-1 flex-wrap">
            {c.status === "closed" && <span className="text-[10px] px-1.5 rounded bg-slate-200 text-slate-600">Closed</span>}
            {c.labels.map((l) => <span key={l} className="text-[10px] px-1.5 rounded bg-emerald-50 text-emerald-700">{l}</span>)}
          </div>
        )}
      </div>
    </button>
  );
}

export function ChatList({ items, active, onOpen, q, setQ, filter, setFilter, onNew }) {
  const [num, setNum] = useState("");
  const [adding, setAdding] = useState(false);
  return (
    <div className="flex flex-col h-full bg-white">
      <div className="h-[60px] px-4 bg-[#f0f2f5] flex items-center justify-between flex-shrink-0">
        <span className="font-semibold text-[#111b21] text-lg">Chats</span>
        <button onClick={() => setAdding((a) => !a)} className="w-9 h-9 rounded-full hover:bg-black/5 flex items-center justify-center text-[#54656f]" title="New chat" data-testid="inbox-new-chat-btn"><Plus className="w-5 h-5" /></button>
      </div>
      {adding && (
        <form className="px-3 py-2 flex gap-2 border-b border-slate-100" onSubmit={(e) => { e.preventDefault(); onNew(num).then((ok) => { if (ok) { setNum(""); setAdding(false); } }); }}>
          <input value={num} onChange={(e) => setNum(e.target.value)} placeholder="10-digit mobile number" className="flex-1 bg-[#f0f2f5] rounded-lg px-3 py-2 text-sm outline-none" data-testid="inbox-new-chat-input" />
          <button className="bg-[#00a884] text-white text-sm font-medium px-3 rounded-lg" data-testid="inbox-new-chat-submit"><Check className="w-4 h-4" /></button>
        </form>
      )}
      <div className="px-3 py-2 flex-shrink-0">
        <div className="flex items-center gap-2 bg-[#f0f2f5] rounded-lg px-3 py-2">
          <Search className="w-4 h-4 text-[#54656f]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, number or message" className="flex-1 bg-transparent text-sm outline-none" data-testid="inbox-search-input" />
        </div>
        <div className="flex gap-1.5 mt-2 overflow-x-auto pb-1">
          {FILTERS.map(([k, l]) => (
            <button key={k} onClick={() => setFilter(k)} data-testid={`inbox-filter-${k}`}
              className={`px-3 py-1 rounded-full text-[13px] whitespace-nowrap transition-colors ${filter === k ? "bg-[#d9fdd3] text-[#008069] font-medium" : "bg-[#f0f2f5] text-[#54656f] hover:bg-[#e9edef]"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto" data-testid="inbox-chat-list">
        {items.map((c) => <ChatRow key={c.phone} c={c} active={active === c.phone} onOpen={onOpen} />)}
        {items.length === 0 && <div className="text-center text-sm text-[#667781] py-12 px-6">No chats here yet. Replies from parents will appear automatically.</div>}
      </div>
    </div>
  );
}
